<template>
    <div>
        <a-modal :visible="isShow" title="修改收货信息" @ok="handleOk" @cancel="handleCancel" width="700px">
            <a-form :model="ruleForm">
                <a-form-item label="地址识别">
                    <a-textarea v-model="addressall" :auto-size="{ minRows: 5, maxRows: 10 }"></a-textarea>
                    <a-button @click="recognition">一键识别</a-button>
                </a-form-item>
                <a-form-item label="tips">
                    <p style="line-height: 24px; color: #999">复制第三方订单详情页的收货地址,然后点击右侧的“一键识别”<br />如：李**,13658626452,广东省 广州市 天河区 *********</p>
                </a-form-item>
                <a-form-item label="收件人">
                    <a-input v-model="ruleForm.name" class="address_width"></a-input>
                </a-form-item>
                <a-form-item label="手机号">
                    <a-input v-model="ruleForm.phone" style="width:200px"></a-input>
                </a-form-item>
                <a-form-item label="所在地区">
                    <a-select placeholder="请选择省" v-model="ruleForm.province_id" @change="getCity" class="address_width">
                        <a-select-option v-for="item in provinceList" :key="'province'+item.id" :value="item.id">{{item.fullname}}</a-select-option>
                    </a-select>
                    <a-select placeholder="请选择市" v-model="ruleForm.city_id" @change="getDistrict" v-show="cityList.length>0?true:false" class="address_width">
                        <a-select-option v-for="item in cityList" :key="'city'+item.id" :value="item.id">{{item.fullname}}</a-select-option>
                    </a-select>
                    <a-select placeholder="请选择地区" v-model="ruleForm.district_id" @change="getStreet" v-show="districtList.length>0?true:false" class="address_width">
                        <a-select-option v-for="item in districtList" :key="'district'+item.id" :value="item.id">{{item.fullname}}</a-select-option>
                    </a-select>
                    <a-select placeholder="请选择街道" v-model="ruleForm.street_id" v-show="streetList.length>0?true:false" class="address_width">
                        <a-select-option v-for="item in streetList" :key="'street'+item.id" :value="item.id">{{item.fullname}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="详细地址">
                    <a-textarea v-model="ruleForm.address" :auto-size="{ minRows: 3, maxRows: 5 }"></a-textarea>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'EditOrderAddressModal',
    model: {
        prop: 'isShow',
        event: 'hidden'
    },
    props: {
        isShow: {
            type: Boolean,
        },
        oldForm: {
            type: Object,
            required: true
        }
    },
    created () {
        this.getProvince()
    },
    data () {
        return {
            addressall: "",
            ruleForm: {
                id: '',
                name: "",
                phone: "",
                province_id: "",
                city_id: "",
                district_id: "",
                street_id: "",
                address: "",
            },
            provinceList: [],
            cityList: [],
            districtList: [],
            streetList: []
        }
    },
    watch: {
        oldForm: {
            handler (data) {
                this.ruleForm = data
            }
        }
    },
    methods: {
        handleOk() {
            this.$util.api('/order/third/receive',this.ruleForm, res => {
                if(res.code == 10000){
                    this.$message.success(res.msg);
                    this.handleCancel();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleCancel() {
            this.ruleForm={
                id: "",
                name: "",
                phone: "",
                province_id: "",
                city_id: "",
                district_id: "",
                street_id: "",
                address: "",
            }
            this.$emit('hidden', false)
        },
        getProvince(){
            this.$util.api('/region',{}, res => {
                if(res.code == 10000){
                    this.provinceList = res.data;
                }
            });
        },
        getCity(){
            this.cityList = [];
            this.districtList = [];
            this.streetList = [];
            this.ruleForm.city_id=''
            this.ruleForm.district_id=''
            this.ruleForm.street_id=''
            if(this.ruleForm.province_id != ''){
                this.$util.api('/region',{
                    id: this.ruleForm.province_id
                }, res => {
                    if(res.code == 10000){
                        // 李**,13658626452,上海市 闵行区 新虹街道 *********
                        this.provinceList.forEach(item=>{
                            if (item.id===this.ruleForm.province_id){
                                this.isShowCity=true;
                                this.cityList = res.data;
                            }
                        })
                    }
                });
            }
            // isShowCity
        },
        getDistrict(){
            this.districtList = [];
            this.streetList = [];

            if(this.ruleForm.city_id != ''){
                this.$util.api('/region',{
                    id: this.ruleForm.city_id
                }, res => {
                    if(res.code == 10000){
                        this.districtList = res.data;
                    }
                });
            }
        },
        getStreet(){
            this.streetList = [];
            if(this.ruleForm.district_id != ''){
                this.$util.api('/region',{
                    id: this.ruleForm.district_id
                }, res => {
                    if(res.code == 10000){
                        this.streetList = res.data;
                    }
                });
            }
        },
        
        recognition() {
            this.$util.api('/discern',{
                str: this.addressall
            },res => {
                console.log(res);
                if(res.code == 10000){
                    this.ruleForm.name = res.data.name;
                    this.ruleForm.phone = res.data.mobile;
                    this.ruleForm.address = res.data.address;
                    this.ruleForm.province_id = res.data.province.id;
                    this.getCity();
                    this.ruleForm.city_id = res.data.city.id;
                    this.getDistrict();
                    this.ruleForm.district_id = res.data.district.id;
                    this.getStreet();
                    this.ruleForm.street_id = res.data.town.id;
                }
            });
        },
    }
}
</script>

<style scoped>
.address_width {
    width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/deal/third/components/EditOrderAddressModal.vue